import { lazy } from "react";
import { basicPlanRenderLoader } from "@ms/uno-view-basicplan/lib/local/controls/adapter/BasicPlanViewLazyLoader";
export const LazyBasicPlanView = /*#__PURE__*/ lazy(()=>basicPlanRenderLoader().then((mod)=>{
        return {
            default: ()=>mod.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
